import script from "./ManagerUserManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./ManagerUserManagement.vue?vue&type=script&setup=true&lang=js"

import "./ManagerUserManagement.vue?vue&type=style&index=0&id=1648cd37&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1648cd37"]])

export default __exports__